import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      padding: 16,
      borderRadius: 10,
      border: '1px solid',
      borderColor: theme.oysterTheme.pearl,
      color: theme.oysterTheme.oyster,
    },
    label: {
      color: theme.oysterTheme.dolphin,
      fontWeight: 600,
      marginBottom: 5,
    },
    value: {
      color: theme.oysterTheme.charcoal,
      fontWeight: 600,
    },
    copyIcon: {
      '& svg path': {
        fill: ({ primaryColor }: StyleProps) => primaryColor,
      },
    },
    accountInfo: {
      '& > .MuiBox-root:first-child': {
        paddingBottom: 24,
        borderBottom: `1px solid ${theme.oysterTheme.stone}`,
      },
      '& > .MuiBox-root + .MuiBox-root': {
        marginTop: 24,
      },
    },
    continueButton: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  }),
);

export default useStyles;
